import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Loader from './components/generics/Loader';
import SnackbarCloseButton from './components/shared/SnackbarCloseButton';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Suspense fallback={<Loader />}>
          <SnackbarProvider maxSnack={3} autoHideDuration={5000} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            action={key => <SnackbarCloseButton sbkey={key} />}>
            <App />
          </SnackbarProvider>
        </Suspense>
      </BrowserRouter>
    </Provider>

  </React.StrictMode>,
  document.getElementById('root')
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
